<template>
  <v-container>
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <v-row class="mt-10">
      <v-col>
        <ResourceCenter/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ServiceExpandable from "../../components/expandables/ServiceExpandable";
import {mapState} from 'vuex';
import ResourceCenter from "../resource_center/ResourceCenter";
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";

export default {
  created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      lang: state => state.Branch.lang,
      branchId: state => state.Branch.branch_id
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function () {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchName,
          this.allBranches,
          this.lang
      )
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        // href: "breadcrumbs_dashboard",
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        disabled: true,
        // href: "breadcrumbs_link_1",
      }
    ],
  }),
  components: {
    ResourceCenter,
  }
};
</script>

<style></style>
